module.exports = __webpack_public_path__ + "img/software_quickbooks.3f68c0b9.jpg";